/**
 * Appends data to a FormData object, handling nested objects and arrays.
 * @param {FormData} formData - The FormData object to append data to.
 * @param {Object} data - The data to append, can be an object, array, or primitive.
 * @param {string} [parentKey=''] - The key to use for the current level of data.
 */
export const appendFormData = (formData, data, parentKey = '') => {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        appendFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else {
        if(data === null || data === undefined){
            formData.append(parentKey,'');
        }
        else{
            formData.append(parentKey, data);
        }
    }
}